export default __webpack_public_path__ + "static/media/showroom41.49f85d12.jpg";